const AlertPop = ({ handleModalClose }) => {
    return (
        <div className="modal_body">
            <div className="attached_courses-alert">
                <h2>Alert!</h2>
                <p className="text_center mt_3">You are trying to delete a skill that has 1 or more courses attached to it.
                    Please remove courses from the skill to proceed.</p>
                <input onClick={() => handleModalClose()} type="reset" className="btn btn_gray d_block mx_auto" value="ok"/>
            </div>
        </div>
    )
};

export default AlertPop;